module.exports = __webpack_public_path__ + "first-10_microprint.jpg?130d1e07b62126d54874dd4e5641ade6";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/first-10_microprint.jpg
// module id = 445
// module chunks = 0